<template>
  <v-container class="pa-0">
    <router-view />
    <div style="width: 100vw; height: 56px;"></div>
    <bottom-navigation />
  </v-container>
</template>
<script>
import BottomNavigation from "../../components/app/BottomNavigation.vue";
export default {
  components: { BottomNavigation },
  name: "Main",
};
</script>